<template>
	<v-card>
		<v-card-title>
			Azione in massa: Prima Scadenza Fattura Esiti Provvisori
		</v-card-title>
		
		<v-card-text>
			<v-row>
				<v-col>
					<v-form ref="formAssegnaInMassaDataScadenzaSaldoEsitiProvvisori">
						<v-menu
							v-model="menuDataScadenzaSaldoEsitiProvvisori"
							:close-on-content-click="false"
							max-width="290"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:value="formatDateToItaly(dataScadenzaSaldoEsitiProvvisori)"
									label="Prima Scadenza Fattura Esiti Provvisori"
									outlined
									dense
									readonly
									v-bind="attrs"
									v-on="on"
									clearable
									@click:clear="dataScadenzaSaldoEsitiProvvisori = null"
									class="mt-1"
									:rules="[mixin_rules.required]"
								></v-text-field>
							</template>
							<v-date-picker
								:value="dataScadenzaSaldoEsitiProvvisori"
								@input="dataScadenzaSaldoEsitiProvvisori = $event !== '' ? $event : null"
								@change="menuDataScadenzaSaldoEsitiProvvisori = false"
								first-day-of-week="1"
							></v-date-picker>
						</v-menu>
					</v-form>
				</v-col>
			</v-row>
		</v-card-text>
		
		<!--<v-divider></v-divider>-->
		
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				class="black--text"
				@click="$emit('close')"
			>
				Chiudi
			</v-btn>
			<v-btn
				color="secondary"
				@click="assegnaInMassaDataScadenzaSaldoEsitiProvvisori()"
				:loading="isLoadingAssegnaInMassaDataScadenzaSaldoEsitiProvvisori"
			>
				Esegui
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		contrattiDiServizioIds: {
			default: []
		}
	},
	data() {
		return {
			menuDataScadenzaSaldoEsitiProvvisori: false,
			dataScadenzaSaldoEsitiProvvisori: null,
			isLoadingAssegnaInMassaDataScadenzaSaldoEsitiProvvisori: false
		}
	},
	
	methods: {
		assegnaInMassaDataScadenzaSaldoEsitiProvvisori() {
			if (!this.$refs.formAssegnaInMassaDataScadenzaSaldoEsitiProvvisori.validate()) return;
			
			this.isLoadingAssegnaInMassaDataScadenzaSaldoEsitiProvvisori = true;
			axios.post('/api/contratti-di-servizio/assegna-in-massa-data-scadenza-saldo-esiti-provvisori', {
				data_scadenza_saldo_esiti_provvisori: this.dataScadenzaSaldoEsitiProvvisori,
				contratti_di_servizio_ids: this.contrattiDiServizioIds
			})
				.then(() => {
					this.$emit('close');
					this.$emit('done');
				})
				.finally(() => {
					this.isLoadingAssegnaInMassaDataScadenzaSaldoEsitiProvvisori = false;
				})
		}
	}
}
</script>